module.exports = __webpack_public_path__ + "img/product_25.0b5bea8.jpg";